const TEMPLATE_BLOCK_TYPE = {
  HEADER: "header",
  COMPANY_INFO: "company_info",
  PROJECT_OVERVIEW: "project_overview",
  CLIENT_INFO: "client_info",
  SALES_PRICE: "sales_price",
  SCOPE_OF_WORK: "scope_of_work",
  INCLUSIONS: "inclusions",
  EXCLUSIONS: "exclusions",
  CLIENT_RESPONSIBILITIES: "client_responsibilities",
  COST_SUMMARY: "cost_summary",
  PAYMENT_SCHEDULE: "payment_schedule",
  WARRANTY: "warranty",
  TERMS_AND_CONDITIONS: "terms_and_conditions",
  // primitives
  FREE_TEXT: "free_text",
  BULLET_LIST: "bullet_list",
  CUSTOM_TABLE: "custom_table",
  IMAGE: "image",
  SIGNATURE_DATE: "signature_date",
  INITIAL_SIGNATURE: "initial_signature",
  APPENDIX_DOCUMENT: "appendix_document",
  SECTION_HEADER: "section_header",
  DIVIDER: "divider"
} as const

type TemplateBlockType =
  (typeof TEMPLATE_BLOCK_TYPE)[keyof typeof TEMPLATE_BLOCK_TYPE]

export { TEMPLATE_BLOCK_TYPE, type TemplateBlockType }
